export const storeEmailListInSessionStorage = (emailId, sessionEmailList, ADD_OR_REMOVE) => {
    if (ADD_OR_REMOVE) {
        if (sessionEmailList) {
            const sessionEmailArray = sessionEmailList.split(",");
            if (!sessionEmailArray.includes(emailId)) {
                sessionEmailArray.push(emailId);
            }
            sessionStorage.setItem("emailList", sessionEmailArray.toString());
        }
        else {
            let sessionEmailArray = [];
            sessionEmailArray.push(emailId);
            sessionStorage.setItem("emailList", sessionEmailArray.toString());
        }
    }
    else {
        if (sessionEmailList) {
            const sessionEmailArray = sessionEmailList.split(",");
            if (sessionEmailArray.includes(emailId)) {
                let emailAtIndex = sessionEmailArray.indexOf(emailId);
                if (emailAtIndex !== -1) {
                    sessionEmailArray.splice(emailAtIndex, 1);
                    sessionStorage.setItem("emailList", sessionEmailArray.toString());
                }
            }
        }
    }
};
